import { controls } from "../../controls";

const rp954= {
  label: "	CASH RESERVE AND LIQUID ASSETS PART-1",
  pageLabel: "	CASH RESERVE AND LIQUID ASSETS PART-1",
  starting: true,
  url: "rp954",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [  
   
    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({ tab: "Modal", label: "Market Value Date", width: "col-sm-2" }),
    ...controls.datePicker({ tab: "Modal", name: "date_picker", width: "col-sm-4", placeHolder: "Date Picker", defaultValue: "" }),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-1 "}),

      ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "ACCOMPANIMENT TO THE CASH RESERVE AND LIQUID ASSETS",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "smo",
        accessor: "domain_code",
        width: 80,
        rwidth:"*"
      },
      {
        Header: "Perticular",
        accessor: "Perticular",
       
        rwidth:"*"
      },
      {
        Header: "Book Value",
        accessor: "Book_Value",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Face Value",
        accessor: "Face_Value",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Market Value",
        accessor: "Market_Value",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Remarks",
        accessor: "Remarkss",
        
        rwidth:"*"
      },
             
    ]
  }
};

export default rp954;